import axios from 'axios';

export const getCronJobs = async () => {
    const { data } = await axios.get('/api/cron/jobs');
    return data;
};

export const getCronQueueStatus = async () => {
    const { data } = await axios.get('/api/cron/queue');
    return data;
};

export const getCronQueueJobs = async (options = {}) => {
    const params = {};
    if (options.lane) params.lane = options.lane;
    if (options.states) params.states = options.states;
    if (options.limit) params.limit = options.limit;
    const { data } = await axios.get('/api/cron/queue/jobs', { params });
    return data;
};

export const removeCronQueueJob = async ({ lane, jobId } = {}) => {
    if (!jobId) {
        throw new Error('jobId is required');
    }
    const payload = {};
    if (lane) payload.lane = lane;
    const { data } = await axios.post(`/api/cron/queue/jobs/${encodeURIComponent(jobId)}/remove`, payload);
    return data;
};

export const promoteCronQueueJob = async ({ lane, jobId } = {}) => {
    if (!jobId) {
        throw new Error('jobId is required');
    }
    const payload = {};
    if (lane) payload.lane = lane;
    const { data } = await axios.post(`/api/cron/queue/jobs/${encodeURIComponent(jobId)}/promote`, payload);
    return data;
};

export const runCronJob = async (jobName) => {
    if (!jobName) {
        throw new Error('jobName is required');
    }
    const { data } = await axios.post(`/api/cron/jobs/${encodeURIComponent(jobName)}/run`);
    return data;
};

export const abortCronJob = async ({ jobName, runId, reason } = {}) => {
    if (!jobName) {
        throw new Error('jobName is required');
    }
    const payload = {};
    if (runId) payload.runId = runId;
    if (reason) payload.reason = reason;
    const { data } = await axios.post(`/api/cron/jobs/${encodeURIComponent(jobName)}/abort`, payload);
    return data;
};

export const abortAllCronJobs = async ({ reason } = {}) => {
    const payload = {};
    if (reason) payload.reason = reason;
    const { data } = await axios.post('/api/cron/jobs/abort-all', payload);
    return data;
};

export const toggleCronJob = async ({ jobName, enabled }) => {
    if (!jobName) {
        throw new Error('jobName is required');
    }
    const { data } = await axios.post(`/api/cron/jobs/${encodeURIComponent(jobName)}/enable`, { enabled });
    return data;
};

export const setCronJobLane = async ({ jobName, lane }) => {
    if (!jobName) {
        throw new Error('jobName is required');
    }
    const resolved = lane === 'priority' ? 'priority' : 'default';
    const { data } = await axios.post(`/api/cron/jobs/${encodeURIComponent(jobName)}/lane`, { lane: resolved });
    return data;
};

export const updateCronJobSchedule = async ({ jobName, schedule, enabled }) => {
    if (!jobName) {
        throw new Error('jobName is required');
    }
    if (!schedule) {
        throw new Error('schedule is required');
    }
    const payload = { schedule };
    if (typeof enabled === 'boolean') payload.enabled = enabled;
    const { data } = await axios.post(`/api/cron/jobs/${encodeURIComponent(jobName)}/schedule`, payload);
    return data;
};

export const updateCronJobTimeout = async ({ jobName, timeoutMs }) => {
    if (!jobName) {
        throw new Error('jobName is required');
    }
    const { data } = await axios.post(`/api/cron/jobs/${encodeURIComponent(jobName)}/timeout`, { timeoutMs });
    return data;
};

export const getCronJobHistory = async (jobName, options = {}) => {
    if (!jobName) {
        throw new Error('jobName is required');
    }
    const params = {};
    if (options.limit) {
        params.limit = options.limit;
    }
    const { data } = await axios.get(`/api/cron/jobs/${encodeURIComponent(jobName)}/history`, { params });
    return data;
};

export const getCronRunSteps = async (jobName, runId, options = {}) => {
    if (!jobName) {
        throw new Error('jobName is required');
    }
    if (!runId) {
        throw new Error('runId is required');
    }
    const params = {};
    if (options.limit) params.limit = options.limit;
    if (options.offset) params.offset = options.offset;
    const { data } = await axios.get(
        `/api/cron/jobs/${encodeURIComponent(jobName)}/runs/${encodeURIComponent(runId)}/steps`,
        { params }
    );
    return data;
};
